// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
  }
};

(function() {
  BoostPFS.inject(this);

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function() {};

  SearchInput.prototype.afterBindEvents = function() {
    // Fix cannot close search suggestion when clicking overlay 
    document.addEventListener('click', function(e) {
      if(this.searchAutoComplete && this.searchAutoComplete.isOpen && e && e.target) {
        var $clickedElement = jQ(e.target);
        var isClickSuggestion = $clickedElement.closest('.' + Class.searchSuggestionWrapper).length > 0;
        if (isClickSuggestion) {
          this.searchAutoComplete.$element.hide();
          this.searchAutoComplete.searchInput.onCloseAutocomplete();
          this.searchAutoComplete.isOpen = false;
        }
      }
    }.bind(this), true);
  }

  /* Starts Boost 204581 */
  InstantSearchResultItemProduct.prototype.afterRender = function () {
    if (this.hasOwnProperty("data") && this.data !== null) {
      var data = this.data;

      var hasShopifyRoutes =
        Shopify && Shopify.routes && typeof Shopify.routes.root != "undefined";
      var localeURLPart = "";

      if (hasShopifyRoutes) {
        localeURLPart = Shopify.routes.root.replace(/\/$/, "");
      }

      var quickUrl =
        localeURLPart +
        "/products/" +
        data.handle +
        "?view=boost-pfs-prod-prices";
      jQ(
        '.boost-pfs-search-suggestion-item[data-id="' +
          data.id +
          '"] .boost-pfs-search-suggestion-product-price.price__discount'
      ).empty();
      jQ.ajax({
        url: quickUrl,
        success: function (result) {
          try {
            const res = JSON.parse(result);
            console.log(123123213, res);
            jQ(
              '.boost-pfs-search-suggestion-item[data-id="' +
                res.id +
                '"] .boost-pfs-search-suggestion-product-price.price__discount'
            ).html(res.ajax_price.trim());
          } catch (error) {
            console.log(error);
          }
        },
      });
    }
  };

  InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice =
    function () {
      // If the multi-currency feature is enabled, update the product price
      this.prepareSuggestionProductPriceData();
      // Check on sale
      var onSale = this.data.compare_at_price_min > this.data.price_min;
      // Format price
      var price = Utils.formatMoney(this.data.price_max);
      var compareAtPrice = this.data.compare_at_price_min
        ? Utils.formatMoney(this.data.compare_at_price_min)
        : "";

      if (this.data) {
        // compareAtPrice = Utils.formatMoney(this.data.compare_at_price_min);
        if (Settings.getSettingValue("search.removePriceDecimal")) {
          price = Utils.removeDecimal(price);
          compareAtPrice = Utils.removeDecimal(compareAtPrice);
        }
      }

      // Build Price
      var result = "";
      if (Settings.getSettingValue("search.showSuggestionProductPrice")) {
        if (
          onSale &&
          Settings.getSettingValue("search.showSuggestionProductSalePrice")
        ) {
          result = this.getTemplate(
            InstantSearchResultItemProduct.tempType.PRICE_SALE
          );
        } else {
          result = this.getTemplate(
            InstantSearchResultItemProduct.tempType.PRICE
          );
        }
      }
      return result
        .replace(/{{regularPrice}}/g, "")
        .replace(/{{compareAtPrice}}/g, "");
    };
  /* Ends Boost 204581 */
})();